import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import ServiceLanding from "@/pages/ServiceLanding";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PanelLayout from "@/panel/PanelLayout";
import Buy from "@/panel/Buy";
import Wallet from "@/panel/Wallet";
import MyNumbers from "@/panel/MyNumbers";
import Affiliate from "@/panel/Affiliate";
import Profile from "@/panel/Profile";
import Admin from "@/admin/Admin";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors theme="system" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sms-onay/:slug" element={<ServiceLanding />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/giris" element={<Login />} />
            <Route path="/kayit" element={<Register />} />
            <Route path="/adc" element={<Admin />} />
            <Route path="/panel" element={<PanelLayout />}>
              <Route index element={<Navigate to="/panel/satin-al" replace />} />
              <Route path="satin-al" element={<Buy />} />
              <Route path="cuzdan" element={<Wallet />} />
              <Route path="numaralarim" element={<MyNumbers />} />
              <Route path="ortaklik" element={<Affiliate />} />
              <Route path="profil" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
